import React from "react";
import { Provider } from "react-redux";

import { Switch, Route } from "react-router-dom";

import Home from "./Routes/Home";
import Error from "./Routes/Error";
import Login from "./Routes/Forms/Login";
import ResetPin from "./Routes/Forms/ResetPin";
import ForgetPin from "./Routes/Forms/ForgetPin";

import Dashboard from "./Routes/Dashboard";
import Profile from "./Routes/Profile";
import Withdraw from "./Routes/Withdraw";
import History from "./Routes/History";
import Transaction from "./Routes/Transaction";

import store from "./store";

function App(props) {
    return (
        <Provider store={store}>
            <Switch>
                <Route path="/" component={Home} exact></Route>
                <Route path="/login" component={Login} exact></Route>
                <Route
                    path="/reset-password"
                    component={ResetPin}
                    exact
                ></Route>
                <Route
                    path="/forget-password"
                    component={ForgetPin}
                    exact
                ></Route>

                <Route path="/dashboard" component={Dashboard} exact></Route>
                <Route path="/user-profile" component={Profile} exact></Route>
                <Route path="/withdraw" component={Withdraw} exact></Route>
                <Route path="/history" component={History} exact></Route>
                <Route
                    path="/history/:id"
                    component={Transaction}
                    exact
                ></Route>
                <Route path="*" component={Error} exact></Route>
            </Switch>
        </Provider>
    );
}

export default App;
